import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/HolidayYearCopyHolidays.css';
import SelectField from '../fields/SelectField';
import useExtendedState from '../../hooks/useExtendedState';
import { holidayYearsType } from '../../types';

HolidayYearCopyHolidays.propTypes = {
    availableHolidayYears: holidayYearsType.isRequired,
    onCopyHolidays: PropTypes.func.isRequired,
};

function HolidayYearCopyHolidays(props) {
    const {
        availableHolidayYears,
        onCopyHolidays,
    } = props;
    const { t } = useTranslation();
    const yearToCopyState = useExtendedState('');
    const isCopyHolidaysButtonDisabled = !yearToCopyState.value;
    const copyHolidays = () => {
        const holidaysToCopy = availableHolidayYears.find((availableHolidayYear) => availableHolidayYear.year === parseInt(yearToCopyState.value, 10)).holidays;
        const newHolidays = holidaysToCopy.map((holidayToCopy) => ({
            id: holidayToCopy.id,
            name: holidayToCopy.name,
            dateWithoutYear: holidayToCopy.holidayDate.substring(5),
            isValid: true,
        }));
        onCopyHolidays(newHolidays);
        yearToCopyState.reset();
    };
    return (
        <div className="holiday-year--copy-holidays">
            <SelectField
                label={t('holidays.year-to-copy')}
                inputId="holiday-year--fields--year-to-copy"
                className="holiday-year--fields--year-to-copy"
                state={yearToCopyState}
                emptyOption={<option value="">...</option>}
                options={availableHolidayYears.map((availableHolidayYear) => (
                    <option
                        key={availableHolidayYear.year}
                        value={availableHolidayYear.year}
                    >
                        {availableHolidayYear.year}
                    </option>
                ))}
            />
            <button
                type="button"
                className="copy-holidays-button button button-bordered"
                disabled={isCopyHolidaysButtonDisabled}
                onClick={copyHolidays}
            >
                <FontAwesomeIcon icon="check" />&nbsp;{t('holidays.copy-holidays')}
            </button>
        </div>
    );
}

export default HolidayYearCopyHolidays;
